module.exports = __webpack_public_path__ + "images/4caceb418058d4f6ca1f6fdae69106fc-course4.jpg";